import React, { memo } from 'react';

import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { StatusEnum } from 'constants/status';

import {
  ErrorFilledIcon,
  ErrorIcon,
  InfoFilledIcon,
  InfoIcon,
  InProgressIcon,
  SuccessFilledIcon,
  SuccessIcon,
  WarningFilledIcon,
  WarningIcon,
} from '../icons';

const statusIconFilledComponentsMap = {
  [StatusEnum.SUCCESS]: SuccessFilledIcon,
  [StatusEnum.ERROR]: ErrorFilledIcon,
  [StatusEnum.WARNING]: WarningFilledIcon,
  [StatusEnum.INFO]: InfoFilledIcon,
  [StatusEnum.IN_PROGRESS]: InProgressIcon,
};

const statusIconOutlinedComponentsMap = {
  [StatusEnum.SUCCESS]: SuccessIcon,
  [StatusEnum.ERROR]: ErrorIcon,
  [StatusEnum.WARNING]: WarningIcon,
  [StatusEnum.INFO]: InfoIcon,
  [StatusEnum.IN_PROGRESS]: InProgressIcon,
};

// info icon does not follow design
const StatusIconCDS = ({ type, size = 20, isOutlined, sx, dataTestId }) => {
  const StatusIconComponent = isOutlined
    ? statusIconOutlinedComponentsMap[type]
    : statusIconFilledComponentsMap[type];

  return (
    StatusIconComponent && (
      <Typography
        className="flex h-fit w-fit"
        color={type}
        data-testid={dataTestId}
        sx={sx}
        variant="regular14"
      >
        <StatusIconComponent size={size} />
      </Typography>
    )
  );
};

StatusIconCDS.propTypes = {
  type: PropTypes.oneOf(Object.values(StatusEnum)).isRequired,
  size: PropTypes.number,
  isOutlined: PropTypes.bool,
  sx: PropTypes.object,
  dataTestId: PropTypes.string,
};

export default memo(StatusIconCDS);
